import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Reveal } from './Reveal';
type FAQItem = {
  question: string;
  answer: string;
};
const faqs: FAQItem[] = [{
  question: 'Comment fonctionne le système ?',
  answer: 'Le système combine 6 tomes thérapeutiques illustrés et 5 bonus cliniques pour vous guider à travers le travail complet des Constellations Familiales — des lois systémiques fondamentales jusqu’à l’intégration finale et l’écriture d’un nouveau récit de vie.'
}, {
  question: 'Ai-je besoin de connaissances préalables ?',
  answer: 'Non. Le système a été conçu pour être accessible aux débutants complets tout en étant suffisamment profond et cliniquement rigoureux pour les praticiens expérimentés.'
}, {
  question: 'Les ressources sont-elles vraiment imprimables ?',
  answer: 'Oui. Toutes les ressources — cartes de constellation, phrases de guérison, modèles de génogramme et fiches de travail — sont formatées en haute résolution pour une impression A4 parfaite.'
}, {
  question: 'Les 5 Bonus sont-ils vraiment gratuits ?',
  answer: 'Oui. Les 5 Bonus Cliniques d’une valeur totale de 75 EUR sont inclus gratuitement avec votre achat de 19 EUR — sans condition ni abonnement.'
}, {
  question: 'Combien de temps ai-je accès au contenu ?',
  answer: 'Accès à vie. Vous téléchargez tous les fichiers immédiatement après l’achat et vous les possédez pour toujours. Aucun abonnement. Aucune limite de temps. Aucun frais récurrent.'
}, {
  question: 'Qu’est-ce qui rend ce système différent des ressources gratuites en ligne ?',
  answer: 'Les ressources gratuites offrent des fragments. Ce système offre une architecture clinique complète — 6 tomes qui se construisent l’un sur l’autre dans un ordre thérapeutique précis, avec des protocoles pas à pas et des ressources imprimables professionnelles prêtes à utiliser en séance.'
}, {
  question: 'Et si cela ne fonctionne pas pour moi ?',
  answer: 'Protection de l’Achat Numérique pendant 7 Jours. Votre achat est protégé pendant 7 jours en cas de double facturation, de problème d’accès que nous ne sommes pas en mesure de résoudre, ou si le produit numérique diffère de manière significative de ce qui est décrit sur cette page. Comme il s’agit d’un contenu numérique à accès immédiat, les remboursements volontaires pour simple changement d’avis ne sont pas disponibles une fois que les fichiers ont été consultés ou téléchargés, sauf lorsque la législation applicable en matière de protection des consommateurs l’exige.'
}];
function Item({
  item,
  index
}: {
  item: FAQItem;
  index: number;
}) {
  const [open, setOpen] = useState(false);
  return <Reveal delay={index * 0.035} data-id="element-58" data-mp="1n8er39meet1z">
      <div className="overflow-hidden rounded-2xl border border-navy/10 bg-white shadow-premium" data-id="element-59" data-mp="1n9hh7fbwcrgu">
        <button className="flex w-full items-center gap-4 p-5 text-left sm:p-6" onClick={() => setOpen(!open)} aria-expanded={open} data-id="element-60" data-mp="1j59prae20xex">
          <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-sage text-sm font-bold text-white" data-id="element-61" data-mp="2r5jdmltzrij">
            ?
          </span>
          <span className="flex-1 font-semibold text-navy" data-id="element-62" data-mp="cfx8zo3f5zqa">{item.question}</span>
          <ChevronDownIcon className={`h-5 w-5 shrink-0 text-sage transition-transform duration-200 ${open ? 'rotate-180' : ''}`} data-id="element-63" data-mp="ci08cyqgp57o" />
        </button>
        <AnimatePresence initial={false} data-id="element-64" data-mp="mcs8a97io45m">
          {open && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.22,
          ease: 'easeOut'
        }} data-id="element-65" data-mp="qf6pypzg8xvb">
              <p className="px-5 pb-6 pl-16 text-sm leading-7 text-slate sm:px-6 sm:pl-[4.5rem]" data-id="element-66" data-mp="2s95y52h9yz3s">{item.answer}</p>
            </motion.div>}
        </AnimatePresence>
      </div>
    </Reveal>;
}
export function FAQ() {
  return <section className="w-full bg-mist px-4 py-20 sm:py-24" data-id="element-67" data-mp="1wxeicyxy33za">
      <div className="mx-auto max-w-3xl" data-id="element-68" data-mp="1wyzegszwquz9">
        <Reveal className="text-center" data-id="element-69" data-mp="2bup2ewonli6m">
          <h2 className="font-serif text-4xl text-navy sm:text-5xl" data-id="element-70" data-mp="2bte071auwihm">
            ❓ Questions <span className="text-sage" data-id="element-71" data-mp="26wdu4qe0bfqi">fréquentes</span>
          </h2>
          <p className="mt-5 text-slate" data-id="element-72" data-mp="1j4yoann0ugai">Tout ce que vous devez savoir avant d’acheter.</p>
        </Reveal>
        <div className="mt-10 space-y-3" data-id="element-73" data-mp="1e76kav93r3py">
          {faqs.map((faq, index) => <Item key={faq.question} item={faq} index={index} data-id="element-74" data-mp="1sv1g4kiepo79" data-mpi={index} />)}
        </div>
      </div>
    </section>;
}